"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useGetSelectedRecipientShop;

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

function useGetSelectedRecipientShop(shops) {
  var formData = (0, _reactRedux.useSelector)((0, _reduxForm.getFormValues)('transfer-create'));

  if (formData && 'recipient' in formData && formData['recipient']) {
    return formData['recipient'];
  }

  return shops.length ? shops[0] : null;
}